// https://vuex.vuejs.org/en/getters.html

export default {
  isUserAdmin(state) {
    return state.user?.admin
  },
  canMergeDuplicates(state) {
    return state.user?.can_merge_duplicates ?? false
  },
  isBrandUser(state) {
    return state.user?.is_brand_user
  },
  isContributor(state) {
    return state.user?.is_contributor
  },
  isViewer(state) {
    return state.user?.is_viewer
  },
  isSignedIn(state) {
    return state.user != null
  },
  unreadNotificationsCount(state) {
    return state.notifications.reduce(
      (cumul, curr) => (curr.unseen ? cumul + 1 : cumul),
      0
    )
  }
}
